import { createMiddleware } from '@shared/redux';
import { LOCATION_CHANGE } from 'connected-react-router';
import { getRequestConversionTypes } from '@domain/dashboard/conversion-types/conversion-types.middlewares';
import { match } from '@shared/utils/match';
import Routes from '@domain/router/routes.constants';

export const dashboardMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [Routes.CAMPAIGN_MANAGER]: state => getRequestConversionTypes(state),
    }),
});
